// translation map
module.exports = {
  'Execute your audience strategy with no limits': {
    chinese: '无限制地执行您的受众策略',
  },
  'Explore 30,000+ Audiences': {
    chinese: '探索30,000多名观众',
    french: 'Explorez plus de 30 000 spectateurs',
    german: 'Erkunden Sie mehr als 30.000 Zuschauer',
    spanish: 'Explora más de 30,000 audiencias',
  },
  'Search for support questions': {
    chinese: '搜索支持问题',
  },
  'Search for audiences, insights, and support': {
    chinese: '搜索受众，见解和支持',
    french: 'Rechercher des audiences, des idées et du soutien',
    german: 'Suchen Sie nach Zielgruppen, Erkenntnissen und Support',
    spanish: 'Buscar audiencias, ideas y apoyo',
  },
  'Get Started': {
    chinese: '开始吧',
    french: '',
    german: '',
    spanish: 'Empezar',
  },
  Audiences: {
    chinese: '观众',
    french: '',
    german: '',
    spanish: '',
  },
  'Customer Insights': {
    chinese: '客户见解',
  },
  'Build a Custom Audience': {
    chinese: '建立您的自定义受众',
    french: '',
    german: '',
    spanish: '',
  },
  'Capture a Custom Audience': {
    chinese: '捕获自定义受众',
    french: '',
    german: '',
    spanish: '',
  },
  'Use first-party data and thousands of behavioral attributes to create a custom audience': {
    chinese: '使用第一方数据和数千个行为属性来创建自定义受众',
  },
  'Find, execute, and scale your audience strategy with higher performance and better insights.': {
    chinese: '通过更高的性能和更好的见解查找，执行和扩展您的受众策略。',
  },
  Explore: {
    chinese: '探索',
  },
  Build: {
    chinese: '建立',
  },
  Browse: {
    chinese: '浏览',
  },
  'Custom Audiences': {
    chinese: '自定义受众群体',
  },
  'Pixel Audiences': {
    chinese: '像素观众',
  },
  'Audience Name': {
    chinese: '受众姓名',
  },
  'Audience Type': {
    chinese: '受众类型',
  },
  Size: {
    chinese: '尺寸',
  },
  Status: {
    chinese: '状态',
  },
  'Created At': {
    chinese: '创建于',
  },
  Conversion: {
    chinese: '广告转换',
  },
  Active: {
    chinese: '活性',
  },
  'Build or Capture a new audience': {
    chinese: '建立或捕获新的受众',
  },
  Capture: {
    chinese: '搜集',
  },
  Icons: {
    chinese: '图标',
  },
  'Recently searched': {
    chinese: '最近搜索过',
    french: 'Récemment recherché',
    german: 'Kürzlich gesucht',
    spanish: 'Recientemente buscado',
  },
  'Browse Audiences': {
    chinese: '浏览受众群体',
    french: 'Parcourir les audiences',
    german: 'Durchsuchen Sie die Zielgruppen',
    spanish: 'Navegar audiencias',
  },
  'My Audiences': {
    chinese: '观众',
    french: 'Mes audiences',
    german: 'Mein Publikum',
    spanish: 'Mis audiencias',
  },
  'Data Feeds': {
    chinese: '数据馈送',
    french: '',
    german: '',
    spanish: 'Fuentes de datos',
  },
  Pixels: {
    chinese: '像素',
    french: 'Flux de données',
    german: 'Datenfeeds',
    spanish: 'Pixeles',
  },
  'Data Modeling': {
    chinese: '数据建模',
    french: 'La modélisation des données',
    german: 'Datenmodellierung',
    spanish: 'Modelado de datos',
  },
}
